export default "__VITE_ASSET__CyKie8pj__"